import React from "react";
import { Box, Button, Text, Title, Tooltip } from "@mantine/core";
import ButtonSvg from "../assets/img/more.svg";
import { Icon } from "@tabler/icons-react";
import CustomBreadcrumbs from "./CustomBreadCrumbs";
interface Props {

  children: React.ReactNode;
 

  
}

const ReusableehrLayout: React.FC<Props> = ({children }) => {
  
  return (
    <Box >
      {/* main box */}
      <Box
        sx={{
          padding: "16px",
        }}
      >
        {/* first box inside main box*/}
        <Box sx={{marginTop:"12px",marginBottom:"16px"}}>
            {/* breadcrumbs part */}

            <CustomBreadcrumbs/>
            
        </Box>
        <Box sx={{marginBottom:"24px"}}>
            {/* heading */}
            <Title sx={{
                fontWeight:700,
                fontSize:"26px",
                lineHeight:"36px"
            }}>Create New Application</Title>
        </Box>
        <Box sx={{marginBottom:"30px"}}>
            {/* children componenet */}
            {children}
        </Box>

      </Box>
      <Box sx={{ padding: "16px" }}>
        {/* using for buttons cancel and create */}
      </Box>
    </Box>
  );
};

export default ReusableehrLayout;
